import { Mail, Phone, ArrowUpRight, Copy, Check } from "lucide-react";
import { useState } from "react";

export const Contact = () => {
  const [copied, setCopied] = useState(null);

  const copy = (value, key) => {
    navigator.clipboard?.writeText(value);
    setCopied(key);
    setTimeout(() => setCopied(null), 1600);
  };

  return (
    <section
      id="contact"
      data-testid="section-contact"
      className="relative border-t border-white/10 bg-[#050505] pt-24 md:pt-32 pb-12"
    >
      <div className="px-6 md:px-12 lg:px-16">
        <div className="font-mono-accent text-[11px] tracking-[0.3em] uppercase text-[#FF3B30]">
          // 04 / Contact
        </div>

        <h2
          data-testid="contact-headline"
          className="font-display font-black uppercase mt-6 leading-[0.85] text-[14vw] md:text-[11vw] lg:text-[9.5vw]"
        >
          Let's
          <br />
          <span className="text-outline">Build.</span>
        </h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-px bg-white/10 border border-white/10">
          <a
            href="mailto:nburgmaier2007@gmail.com"
            data-testid="contact-email"
            className="md:col-span-7 bg-[#0a0a0a] p-8 md:p-10 group hover:bg-[#111] transition-colors"
          >
            <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40 flex items-center gap-2">
              <Mail size={12} /> Email
            </div>
            <div className="mt-4 font-display font-bold text-2xl md:text-4xl lg:text-5xl break-all group-hover:text-[#FF3B30] transition-colors">
              nburgmaier2007@gmail.com
            </div>
            <div className="mt-6 flex items-center gap-4">
              <span className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40">
                Open mail client
              </span>
              <ArrowUpRight
                size={16}
                className="text-white/40 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
              />
              <button
                type="button"
                data-testid="copy-email-btn"
                onClick={(e) => {
                  e.preventDefault();
                  copy("nburgmaier2007@gmail.com", "email");
                }}
                className="ml-auto font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/50 hover:text-white border border-white/15 px-3 py-2 inline-flex items-center gap-2"
              >
                {copied === "email" ? <Check size={12} /> : <Copy size={12} />}
                {copied === "email" ? "Copied" : "Copy"}
              </button>
            </div>
          </a>

          <a
            href="tel:+16127991459"
            data-testid="contact-phone"
            className="md:col-span-5 bg-[#0a0a0a] p-8 md:p-10 group hover:bg-[#111] transition-colors"
          >
            <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40 flex items-center gap-2">
              <Phone size={12} /> Phone
            </div>
            <div className="mt-4 font-display font-bold text-2xl md:text-4xl group-hover:text-[#FF3B30] transition-colors">
              612-799-1459
            </div>
            <div className="mt-6 flex items-center gap-4">
              <span className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40">
                Call / Text
              </span>
              <ArrowUpRight
                size={16}
                className="text-white/40 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
              />
              <button
                type="button"
                data-testid="copy-phone-btn"
                onClick={(e) => {
                  e.preventDefault();
                  copy("612-799-1459", "phone");
                }}
                className="ml-auto font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/50 hover:text-white border border-white/15 px-3 py-2 inline-flex items-center gap-2"
              >
                {copied === "phone" ? <Check size={12} /> : <Copy size={12} />}
                {copied === "phone" ? "Copied" : "Copy"}
              </button>
            </div>
          </a>
        </div>

        {/* Meta grid */}
        <div className="mt-px grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border-l border-r border-b border-white/10">
          {[
            { k: "Based in", v: "Minneapolis, MN" },
            { k: "Status", v: "Open to opportunities" },
            { k: "Focus", v: "Robotics / Mechanical" },
            { k: "Response", v: "< 24 hours" },
          ].map((m, i) => (
            <div key={i} className="bg-[#0a0a0a] p-6">
              <div className="font-mono-accent text-[9px] tracking-[0.3em] uppercase text-white/40">
                {m.k}
              </div>
              <div className="font-display font-bold text-base md:text-lg mt-2">
                {m.v}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-24 border-t border-white/10 pt-10 px-6 md:px-12 lg:px-16 pb-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40">
            © {new Date().getFullYear()} Noah Burgmaier — Built in Minneapolis
          </div>
          <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40">
            Portfolio v.01 / High School Engineering
          </div>
        </div>
      </footer>
    </section>
  );
};
